module.exports = __webpack_public_path__ + "static/media/logo-artsteps.1d554418.png";